import * as ActionTypes from './actionTypes';

// CREATE DISCOVER PLACE
export const actionCreateDiscoverPlace = (payload) => ({
  payload,
  type: ActionTypes.CREATE_DISCOVER_PLACE,
});

export const actionCreateDiscoverPlaceSuccess = (payload) => ({
  payload,
  type: ActionTypes.CREATE_DISCOVER_PLACE_SUCCESS,
});

export const actionCreateDiscoverPlaceFailed = (payload) => ({
  payload,
  type: ActionTypes.CREATE_DISCOVER_PLACE_FAILED,
});

// GET DISCOVER PLACE LIST
export const actionGetDiscoverPlaceList = (payload) => ({
  payload,
  type: ActionTypes.GET_DISCOVER_PLACE_LIST,
});

export const actionGetDiscoverPlaceListSuccess = (payload) => ({
  payload,
  type: ActionTypes.GET_DISCOVER_PLACE_LIST_SUCCESS,
});

export const actionGetDiscoverPlaceListFailed = (payload) => ({
  payload,
  type: ActionTypes.GET_DISCOVER_PLACE_LIST_FAILED,
});

export const actionCleanupDiscoverPlaceList = () => ({
  type: ActionTypes.CLEANUP_DISCOVER_PLACE_LIST,
});

// DELETE DISCOVER PLACE
export const actionDeleteDiscoverPlace = (payload) => ({
  payload,
  type: ActionTypes.DELETE_DISCOVER_PLACE,
});

export const actionDeleteDiscoverPlaceSuccess = (payload) => ({
  payload,
  type: ActionTypes.DELETE_DISCOVER_PLACE_SUCCESS,
});

export const actionDeleteDiscoverPlaceFailed = (payload) => ({
  payload,
  type: ActionTypes.DELETE_DISCOVER_PLACE_FAILED,
});

// GET DISCOVER PLACE DETAILS
export const actionGetDiscoverPlaceDetails = (payload) => ({
  payload,
  type: ActionTypes.GET_DISCOVER_PLACE_DETAILS,
});

export const actionGetDiscoverPlaceDetailsSuccess = (payload) => ({
  payload,
  type: ActionTypes.GET_DISCOVER_PLACE_DETAILS_SUCCESS,
});

export const actionGetDiscoverPlaceDetailsFailed = (payload) => ({
  payload,
  type: ActionTypes.GET_DISCOVER_PLACE_DETAILS_FAILED,
});

export const actionCleanupDiscoverPlaceDetails = () => ({
  type: ActionTypes.CLEANUP_DISCOVER_PLACE_DETAILS,
});

// UPDATE DISCOVER PLACE
export const actionUpdateDiscoverPlace = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_DISCOVER_PLACE,
});

export const actionUpdateDiscoverPlaceSuccess = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_DISCOVER_PLACE_SUCCESS,
});

export const actionUpdateDiscoverPlaceFailed = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_DISCOVER_PLACE_FAILED,
});
